import classNames from 'classnames';
import { isEmpty } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { SwapIcon } from 'tdesign-icons-react';
import { Image, Tooltip } from 'tdesign-react';

import Empty from '@/assets/image/editor/aigc_image_style.png';
import { useTypedSelector } from '@/store';
import { isPic } from '@/utils/getApiDomain';

import styles from './index.module.less';

export interface IProps {
  value: string;
  disabled: boolean;
  onChange: (key: string) => void;
}

export interface IModel {
  name: string;
  desc: string;
  pic: string;
  mjStyleAlias: string;
  mjPic?: string;
}

const CustomAigcModel: React.FC<IProps> = (props) => {
  const { value, disabled, onChange } = props;
  const { category = '' } = useTypedSelector(store => store.tag)
    .find((e: any) => e.type === (isPic ? 'picbook' : 'style'))
    || { category: '' };
  const modelList: IModel[] = useMemo(() => {
    try {
      return JSON.parse(category) || [];
    } catch {
      return [];
    }
  }, [category]);

  const defaultModel = useMemo(() => modelList?.[0], [modelList]);
  const [activeItem, setActive] = useState<IModel | undefined>(defaultModel);

  useEffect(() => {
    if (!isEmpty(modelList)) {
      const foundModel = modelList?.find(e => e.name === value);
      const targetModel = foundModel || defaultModel;

      if (targetModel.name !== activeItem?.name) {
        setActive(targetModel);
      }

      if (targetModel.name !== value) {
        onChange(targetModel.name);
      }
    }
  }, [value, activeItem?.name, defaultModel?.name, modelList, onChange]);

  const handleSelect = (item: IModel) => {
    if (item.name !== value) {
      onChange(item.name);
    }
  };

  return (
    <Tooltip
      placement='right'
      trigger='click'
      disabled={disabled}
      overlayInnerStyle={{ padding: 0, right: 20 }}
      content={<div className={styles.list} >
        {modelList.map((e, i) => {
          const selected = activeItem?.name === e.name;
          return <div key={i}
            onClick={() => handleSelect(e)}
            className={classNames({ [styles.active]: selected }, styles.model)}
          >
            <Image src={e.pic} fit='cover' className={styles.imageInner} />
            <div className={styles.name}>{e.name}</div>
          </div>;
        })}
      </div>}
    >
      <div className={classNames(styles.container, { [styles.disabled]: disabled })} >
        <div className={styles.left}>
          <Image
            src={activeItem?.pic || Empty}
            fit='cover'
            className={styles.imageOuter}
            error={''}
          />
          <div className={styles.title}>
            <div className={styles.name}>{activeItem?.name || '未选择'}</div>
            {activeItem?.desc && <div className={styles.desc}>{activeItem?.desc}</div>}
          </div>
        </div>
        <div className={styles.icon}>
          <SwapIcon size={20} />
        </div>
      </div>
    </Tooltip>
  );
};

export default CustomAigcModel;
